import type {Endpoints} from "@hosttools/web/server/routes/routes.pricing.types";

import type {OverridePrices} from "../../models/custom";
import type {ListingChannel} from "../../models/listing";
import {Base} from "../base";

type OverrideAvailabilityPayload = {
    availabilities: {
        isOverrideAvailability: boolean;
    };
    startDate: string;
    endDate: string;
    listingID: string;
};

class PricingService extends Base<Endpoints> {
    async getPrices(
        listingID: string,
        starting: "today" | "yesterday" | "lastMonth" | "lastYear",
        isDemo?: boolean
    ) {
        const data = await this.get(
            "/getPrices/:listingID/:starting",
            {
                listingID,
                starting
            },
            {
                demo: isDemo ? "true" : undefined
            }
        );

        return data;
    }

    async setPriceOverride(
        startDate: string,
        endDate: string,
        listingID: string,
        prices: OverridePrices
    ): Promise<void>;

    async setPriceOverride(
        startDate: string,
        endDate: string,
        listingID: string,
        prices: number
    ): Promise<void>;

    async setPriceOverride(
        startDate: string,
        endDate: string,
        listingID: string,
        prices: number | OverridePrices
    ): Promise<void> {
        const url = "/setPriceOverride";
        const pricePayload =
            typeof prices !== "object"
                ? {
                      all: {
                          price: prices
                      }
                  }
                : Object.keys(prices).reduce((arr, channel) => {
                      if (prices[channel]) {
                          arr[channel] = {
                              price: prices[channel]
                          };
                      }
                      return arr;
                  }, {} as Partial<Record<ListingChannel, {price: number}>>);

        const {data} = await this.http.post(url, {
            startDate,
            endDate,
            listingID,
            prices: pricePayload
        });

        return data;
    }

    async overrideAvailability(payload: OverrideAvailabilityPayload) {
        const url = "/setAvailability";
        const {data} = await this.http.post(url, payload);
        return data;
    }
}

export default PricingService;
